import type { NodeJSON } from '../../../api';

export const resolveAgentModelSettings = (
  currentModelId: string | undefined | null,
  previousModelId: string | undefined,
  apiModelId: string | undefined | null,
  apiSettings: NodeJSON | undefined | null,
  currentSettings: NodeJSON | undefined | null,
  modelDefaults: NodeJSON | undefined
): NodeJSON | null | undefined => {
  if (!currentModelId) return null;

  if (previousModelId !== undefined && currentModelId === previousModelId) {
    return currentSettings ?? modelDefaults;
  }

  return Object.keys(apiSettings || {}).length > 0 &&
    currentModelId === apiModelId
    ? apiSettings
    : modelDefaults;
};
